<template>
  <v-container class="driver-list">
    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <data-table
      :list_name="'request-helper'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :type="'driver'"
      :url="`/request-helpers`"
      @printRequest="printRequest"
    />
    <div class="print-area print-hidden-content">
      <div class="contact-area">
        <print-detail
          :request="request_helper"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import printHtmlBlock from 'print-html-block';
export default {
  name: "RequestDriverList",
  components: {
    DataTable: () => import('../components/datatable'),
    PrintDetail: () => import('../components/print-detail'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Request Date', value: 'createdAt' },
      { text: 'Contact Name', value: 'contact_name' },
      { text: 'Phone Number', value: 'phone_number' },
      { text: 'Email', value: 'email' },
      { text: 'Line ID', value: 'line_id' },
      { text: 'Status', value: 'status_name' },
      { text: 'Province', value: 'province_name_en' },
      { text: 'Helper Code', value: 'request_helper_code' },
      { text: '', value: 'actions', sortable: false, cellClass: "fixed-right" }
    ],
    search_attribute: ['contact_name', 'phone_nubmer', 'email', 'line_id', 'status_name',
      'province_name_en', 'request_helper_code'],
    search_param: '',
    attribute_list: ['id', 'contact_name', 'phone_number', 'email', 'line_id', 'status_name',
      'province_name_en', 'request_helper_code', 'createdAt'],
    request_helper: {},
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    },
    printRequest (data) {
      this.request_helper = data
      printHtmlBlock('.print-area', { importStyle: true })
    }
  },
};
</script>

<style scope>
.print-hidden-content {
  display: none;
}
@media print {
  .print-hidden-content {
    display: block;
  }
}
.driver-list .fixed-right {
  position: sticky;
  right: 0;
  min-width: 200px;
  background: white;
  border-left: thin solid rgba(0, 0, 0, 0.12);
}
.driver-list .fixed-right::after {
  box-shadow: inset -10px 0 8px -8px #00000026;
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translate(-100%);
  transition: box-shadow .3s;
  content: "";
  pointer-events: none;
}
@media screen and (min-width: 1200px) {
  .driver-list .fixed-right {
    width: 300px;
  }
}
.driver-list table {
  border-collapse: collapse;
}
</style>
